import { Pagination, styled } from '@mui/material';

export const NumberPagination = styled(Pagination)`
  button {
    color: #605d64;
    margin: 0 8px;
    border: none;
    &:hover {
      background-color: transparent !important;
      color: #5546a9;
      font-size: 18px;
      font-weight: 700;
    }
  }
  .Mui-selected {
    border: none;
    background-color: transparent !important;
    color: #5546a9;
    font-size: 18px;
    font-weight: 700;
  }
`;
